import React from "react"

import { StyledSideDrawer } from "./SideDrawer.styled"

import NavColumn from "../NavColumn/NavColumn"

const SideDrawer = ({ open, setOpen }) => {
  return (
    <StyledSideDrawer open={open}>
      <NavColumn setOpen={setOpen} />
    </StyledSideDrawer>
  )
}

export default SideDrawer
